import ApiResourceManager from '../ApiResourceManager';
import { buildSlugAvailabilityParams } from '../transforms';

export default class FranchisesManager extends ApiResourceManager {
  get = (params) =>
    this.request({
      method: 'GET',
      url: '/franchises',
      params,
    });

  show = (id) =>
    this.request({
      method: 'GET',
      url: `/franchises/${id}`,
    });

  // Inline slug availability check — the onboarding wizard's (FOO-6351) and the franchise
  // modal's. Answers { slug, available, reason }, `reason` naming why a slug is not free
  // (`reserved`, `taken`; on a partner's own root also `invalid_label`, `taken_elsewhere`).
  // Slugs are unique per shop root: `shopDomainId` is the root to check against, and
  // `franchiseId` the franchise being edited — see buildSlugAvailabilityParams.
  checkSlugAvailability = (slug, { shopDomainId = null, franchiseId = null } = {}) =>
    this.request({
      method: 'GET',
      url: '/franchises/slug-available',
      params: buildSlugAvailabilityParams(slug, { shopDomainId, franchiseId }),
    });

  create = (data) =>
    this.request({
      method: 'POST',
      url: '/franchises',
      data,
    });

  update = (id, data) =>
    this.request({
      method: 'POST',
      url: `/franchises/${id}`,
      data,
    });

  delete = (id) =>
    this.request({
      method: 'DELETE',
      url: `/franchises/${id}`,
    });

  syncLieferandoInfo = (id, data) =>
    this.request({
      method: 'PUT',
      url: `/franchises/${id}/lieferando-brand`,
      data,
    });

  partialUpdate = (id, data) =>
    this.request({
      method: 'PATCH',
      url: `/franchises/${id}/partial`,
      data,
    });

  // The restaurant's own domain for its online shop, record by record, as the backend's
  // checks last saw it: `{ data: null }` without one. Saving it stays on update/partial.
  getDomain = (id) =>
    this.request({
      method: 'GET',
      url: `/franchises/${id}/domain`,
    });

  // "Check again": queues a fresh look (202) and answers with the domain as it stands.
  verifyDomain = (id) =>
    this.request({
      method: 'POST',
      url: `/franchises/${id}/domain/verify`,
    });
}
